import { useCallback, useState } from 'react';
import { FormList, TitleLabel } from '@Components/Common/FormComponent';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { dpApprovedSenderEmailEntriesSelector } from '@Policy/store/filters/dlp/selectors';
import { DlpPolicyItem } from '@Policy/utils/types';
import { isEqual } from 'lodash';
import { useTranslation } from 'react-i18next';
import ImportModal from '../../../../AdvancedThreatProtection/PolicyTemplate/Components/ImportModal';
import { generalExport } from '@Policy/utils/fns';

const DlpApprovedSenders = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore)<DlpPolicyItem>;
  const { t } = useTranslation();
  // get state from store
  const dpApprovedSenderEmailEnabled = policySelector(
    (s) => s.tmDpfilters.dpApprovedSenderEmailEnabled
  );
  const approvedSenderList = contextSelector(
    dpApprovedSenderEmailEntriesSelector,
    isEqual
  );
  // config
  const approvedListMaxCount = contextSelector(
    (s) => s.config.limitation.approvedListMaxCount
  );
  // get action from store
  const setDpState = contextSelector((s) => s.setDpState);
  const addDlpApprovedSender = contextSelector((s) => s.addDlpApprovedSender);
  const removeDlpApprovedSender = contextSelector(
    (s) => s.removeDlpApprovedSender
  );
  const importDlpApprovedSender = contextSelector(
    (s) => s.importDlpApprovedSender
  );

  // local state
  // approved sender list
  // status change
  const handleApprovedSenderEmailEnabledChange = useCallback(() => {
    setDpState({
      dpApprovedSenderEmailEnabled: dpApprovedSenderEmailEnabled ? 0 : 1,
    });
  }, [dpApprovedSenderEmailEnabled, setDpState]);
  // export
  const handleApporvedSenderListExport = useCallback((entries: any) => {
    generalExport({
      entries: entries.map((entry: any) => entry.value),
      name: 'approved-sender-list',
    });
  }, []);
  // import
  const [
    isApprovedSenderImportModalVisible,
    setIsApprovedSenderImportModalVisible,
  ] = useState(false);

  const handleApprovedSenderImport = useCallback(
    (entries: any) => {
      console.log('import entries', entries);
      importDlpApprovedSender(entries as string[]);
      setIsApprovedSenderImportModalVisible(false);
    },
    [importDlpApprovedSender]
  );

  return (
    <>
      <TitleLabel title={t('policy.title.senders')} />
      <FormList
        onAdd={addDlpApprovedSender}
        onDelete={removeDlpApprovedSender}
        onExport={handleApporvedSenderListExport}
        onImport={() => setIsApprovedSenderImportModalVisible(true)}
        list={approvedSenderList}
        limit={approvedListMaxCount}
        status={!!dpApprovedSenderEmailEnabled}
        setStatus={handleApprovedSenderEmailEnabledChange}
        label={t('policy.approvedSenderList.title')}
        description={t('policy.approvedSenderList.supportWildcardDesc')}
      />
      <ImportModal
        isVisible={isApprovedSenderImportModalVisible}
        onClose={() => setIsApprovedSenderImportModalVisible(false)}
        onImport={handleApprovedSenderImport}
      />
    </>
  );
};

export default DlpApprovedSenders;
